import React, {useState, useEffect} from "react";
import {Input, Box, Select, styled, Stack, Button} from "@mui/material";
import {theme} from "@material-ui/core";
//import Select, { StylesConfig } from "react-select";

const TXTRoundedDiv = styled("div") (({theme}) => ({
 borderRadius: theme.shape.borderRadius,
 border: "1px solid #6BD5C0",
 width: "100%"
}));

const StyledBox = styled(Box)({
    marginLeft: "10px",
    marginRight: "10px",
    marginTop: "10px",
});

const StyledInput = styled(Input)({
  width: "100%",
  height: "100%",
  fontSize: "14px",
  marginBottom: "2px",
  marginTop: "2px"
});

export default function FRMNewProject ({props}) {
  return(
   <Stack direction="row" spacing={1}>

     <StyledBox flex={4}>
        <span>ABC</span>
        <TXTRoundedDiv>
            <StyledInput
            placeholder="Project name"
            onChange={()=>{

            }}
             />

        </TXTRoundedDiv>
        
        <Button>ABCDEFGH</Button>
     </StyledBox>

   </Stack> 
  )
}